import { createAsyncThunk } from "@reduxjs/toolkit";

import { fetchNotificationsList } from "../../apis/notificationList";

export const fetchNotificationListData = createAsyncThunk(
  "notificationlList/fetchNotificationList",
  async (_, { rejectWithValue }) => {
    try {
      const notificationlList = await fetchNotificationsList();
      return notificationlList.data;
    } catch (error: any) {
      console.log("error->", error);
      return rejectWithValue(error.message);
    }
  },
  {
    condition: (_, { getState }) => {
      const state = getState() as any; // Replace 'any' with your RootState type
      return !state.notificationList.isDataFetched; // Adjust path based on your state structure
    },
  }
);
